
































import { Component,Vue } from 'vue-property-decorator'
import { State,Getter,Action,namespace } from 'vuex-class'
import Aside from './components/aside.vue'

@Component({
    components:{
        Aside
    }
})
export default class Index extends Vue{
    @Getter('loginuser') loginuser:any
    exit(e:string):void {
        console.log(this.$confirm);
        if(e === 'exit'){
            this.$confirm('确定需要退出登陆吗?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await this.$store.dispatch('logout');
                localStorage.removeItem('token');
                location.href = `${location.origin}/login`
            })
            console.log(e);
        }
        
    }
    
}
